(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-brand-marquee"] && !Shopify.designMode) return;
  try {
    
  class BrandMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.about-brand-marquee__track');
      this.content = this.querySelector('.about-brand-marquee__content');

      if (!this.track || !this.content) return;

      /* Clone content nodes for seamless loop */
      for (let i = 0; i < 3; i++) {
        this.track.appendChild(this.content.cloneNode(true));
      }

      /* Pause when off-screen */
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.removeAttribute('paused');
            } else {
              this.setAttribute('paused', '');
            }
          });
        },
        { threshold: 0 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('brand-marquee')) {
    customElements.define('brand-marquee', BrandMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bespoke-process"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bespoke-process')) {
    customElements.define(
      'bespoke-process',
      class BespokeProcess extends HTMLElement {
        connectedCallback() {
          this.buttons = this.querySelectorAll('.bespoke-process__step');
          this.panels = this.querySelectorAll('.bespoke-process__step-content');
          this.bgLayers = this.querySelectorAll('.bespoke-process__bg-layer');
          this.sectionRoot = this.querySelector('.bespoke-process');
          this.autoplayMs = 6200;

          if (!this.buttons.length || !this.panels.length) return;

          this.boundGoToFromStepButton = this.handleStepButtonClick.bind(this);
          this.buttons.forEach((button) => {
            button.addEventListener('click', this.boundGoToFromStepButton);
          });

          const prevHit = this.querySelector('.bespoke-process__hit--prev');
          const nextHit = this.querySelector('.bespoke-process__hit--next');
          if (prevHit) {
            prevHit.addEventListener('click', () => this.stepBy(-1));
          }
          if (nextHit) {
            nextHit.addEventListener('click', () => this.stepBy(1));
          }

          if (this.isInteractiveCarousel()) {
            requestAnimationFrame(() => this.restartActiveLineAnimation());
            this.scheduleAutoplay();
          }
        }

        disconnectedCallback() {
          if (this._autoplayTimer) {
            clearTimeout(this._autoplayTimer);
            this._autoplayTimer = null;
          }
        }

        isInteractiveCarousel() {
          return (
            this.sectionRoot &&
            this.sectionRoot.classList.contains('bm-bespoke-home') &&
            this.buttons.length > 1
          );
        }

        handleStepButtonClick(event) {
          const idx = parseInt(event.currentTarget.dataset.stepIndex, 10);
          if (Number.isNaN(idx)) return;
          this.goToStep(idx);
        }

        stepBy(delta) {
          const active = this.querySelector('.bespoke-process__step--active');
          const current = active ? parseInt(active.dataset.stepIndex, 10) : 0;
          if (Number.isNaN(current)) return;
          this.goToStep(current + delta);
        }

        goToStep(index, opts) {
          const max = this.buttons.length - 1;
          let i = index;
          if (i < 0) {
            i = max;
          }
          if (i > max) {
            i = 0;
          }

          const indexStr = String(i);

          this.buttons.forEach((button) => {
            const isActive = button.dataset.stepIndex === indexStr;
            button.classList.toggle('bespoke-process__step--active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          this.panels.forEach((panel) => {
            const isActive = panel.dataset.stepIndex === indexStr;
            panel.classList.toggle('bespoke-process__step-content--active', isActive);
          });

          if (this.bgLayers && this.bgLayers.length) {
            this.bgLayers.forEach((layer) => {
              const isActive = layer.dataset.stepIndex === indexStr;
              layer.classList.toggle('bespoke-process__bg-layer--active', isActive);
            });
          }

          if (this.isInteractiveCarousel()) {
            this.restartActiveLineAnimation();
            this.scheduleAutoplay();
          }
        }

        restartActiveLineAnimation() {
          if (!this.isInteractiveCarousel()) return;
          this.querySelectorAll('.bespoke-process__step-line').forEach((line) => {
            line.classList.remove('bespoke-process__step-line--fill');
          });
          const activeLine = this.querySelector('.bespoke-process__step--active .bespoke-process__step-line');
          if (activeLine) {
            void activeLine.offsetWidth;
            requestAnimationFrame(() => activeLine.classList.add('bespoke-process__step-line--fill'));
          }
        }

        scheduleAutoplay() {
          if (this._autoplayTimer) {
            clearTimeout(this._autoplayTimer);
            this._autoplayTimer = null;
          }
          if (!this.isInteractiveCarousel()) return;
          this._autoplayTimer = setTimeout(() => {
            const active = this.querySelector('.bespoke-process__step--active');
            const current = active ? parseInt(active.dataset.stepIndex, 10) : 0;
            if (Number.isNaN(current)) return;
            this.goToStep(current + 1);
          }, this.autoplayMs);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-collection-tag-highlights"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bm-collection-tags-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panelId = btn.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        var willOpen = !isOpen;
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) {
          panel.removeAttribute('hidden');
          panel.classList.remove('bm-collection-our-tags__row--extra-collapsed');
          panel.setAttribute('aria-hidden', 'false');
        } else {
          panel.setAttribute('hidden', '');
          panel.classList.add('bm-collection-our-tags__row--extra-collapsed');
          panel.setAttribute('aria-hidden', 'true');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-landing-press"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bm-landing-press-marquee')) {
    class BmLandingPressMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.bm-landing-press__track');
        this.set = this.querySelector('.bm-landing-press__set');

        if (!this.track || !this.set) return;

        for (let i = 0; i < 3; i += 1) {
          this.track.appendChild(this.set.cloneNode(true));
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.removeAttribute('paused');
              } else {
                this.setAttribute('paused', '');
              }
            });
          },
          { threshold: 0 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }
    }

    customElements.define('bm-landing-press-marquee', BmLandingPressMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBreadcrumbBack(root) {
      var scope = root || document;
      scope.querySelectorAll('[data-breadcrumb-back]').forEach(function (el) {
        if (el.dataset.breadcrumbBackInit === 'true') {
          return;
        }
        el.dataset.breadcrumbBackInit = 'true';
        el.addEventListener('click', function (event) {
          var ref = document.referrer;
          if (ref && ref.indexOf(window.location.origin) === 0) {
            event.preventDefault();
            window.history.back();
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initBreadcrumbBack();
      });
    } else {
      initBreadcrumbBack();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initBreadcrumbBack(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
